 <!-- Usage for header, DONT use inline CSS
  <tl-accordion headerName="Employee Info">
   <template v-slot:accordionHeader>
          <span>Employee</span>
          <span style="float:right;padding-right: 20px;">10000</span>
        </template>
   </tl-accordian> -->
/*
  Author: Vaishnavi
  Date: 18/11/2019
  Issue Description: Spacing fixes done as per design guidelines
*/
<template>
    <div class="d-payroll__accord"  >
      <div class="d-payroll__accordBlock" :class="{ active : isActive }" >
        <div class="accordHeading d-heading" @click="isActive = !isActive">
            <slot name="accordionHeader">{{ headerName }}</slot>
        </div>
        <div class="accordContent">
            <div class="row">
              <div class="col-12">
                <div class="icon">
                  <slot name="accordionBody"></slot>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: "Accordion",
  props:{
    'headerName' : {
      type: String
    },
    'active': {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isActive: this.active
    }
  }
};
</script>

<style lang="scss" scoped>
 @import '@/scss/dashboard/_variables.scss';
 @import '@/scss/dashboard/content/_section.scss';
//  .accordContent{
//    padding: 0px 0px 0px 20px;
//  }

</style>
